import type { BankConnection } from "@/apis/gql/types";
import { useTenant } from "@/providers/session";
import { gql, useQuery } from "@apollo/client";

export const useGetAllBankConnections = ({
  enabled = true,
  fetchPolicy,
}: {
  enabled?: boolean;
  fetchPolicy?: "cache-first" | "cache-and-network" | "network-only";
} = {}) => {
  const { tenantId } = useTenant();

  const { data, error, loading, refetch } = useQuery<{
    bankConnections: BankConnection[];
  }>(BANK_CONNECTIONS_QUERY, {
    variables: { tenantId },
    fetchPolicy,
  });

  return {
    bankConnections: data?.bankConnections ?? [],
    error,
    loading,
    refetch,
  };
};

export const BANK_CONNECTIONS_QUERY = gql`
  query GetBankConnections($tenantId: String!) {
    bankConnections(tenantId: $tenantId) {
      bankConnectionId
      finapiBankId
      bankName
      connectionName
      iban
      createdAt
      updatedAt
      txnImportEnabled
      shouldAddFints
      accounts {
        bankAccountId
        finapiAccountId
        name
        accountNumber
        type
        iban
        defaultAccount
        maxCollectivePayments
        balance
        currency
        journalAccounts {
          journalAccountId
          name
          number
          entityId
        }
      }
      reauthRequired
      metadata {
        id
        interfaces {
          bankingInterface
        }
        bank {
          name
          bic
          blz
          location
          city
          isTestBank
          popularity
          isBeta
          logo {
            url
          }
          icon {
            url
          }
          bankGroup {
            name
            icon {
              url
            }
            logo {
              url
            }
          }
          interfaces {
            bankingInterface
            health
            isAisSupported
            isPisSupported
            aisCapabilities {
              standingOrdersDownload
              pendingTransactionsDownload
            }
            paymentCapabilities {
              sepaMoneyTransfer
              sepaInstantMoneyTransfer
            }
          }
        }
      }
    }
  }
`;
